let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("VrQDy")).then(() => parcelRequire('dwy4h'));